import React from 'react';

import { lang } from 'src/helpers';

export default class CallItem extends React.PureComponent {
  render() {
    let { item } = this.props;
    let { own, data } = item;

    let text = own ? 'Outgoing ' : 'Incoming ';
    if (data.isVideo) text += 'video ';
    text += 'call';
    if (!data.requestDate && data.startDate) data.requestDate = data.startDate;
    let duration = Math.round((data.endDate - (data.responseDate || data.requestDate)) / 1000);
    if (duration > 60) {
      duration = Math.round(duration / 60) + ' ' + lang.t('minutes');
    } else {
      duration += ' ' + lang.t('seconds');
    }

    return (
      <div className={'mc-flex-col'}>
        <div className={'mc-value-618'}>{text}</div>
        <pre className={'mc-label-416'}>{duration}</pre>
      </div>
    );
  }
}
